import React from 'react';
import { BrowserRouter as Router, Routes, Route, useNavigate, useParams } from 'react-router-dom';
import Home from './components/Home';
import About from './components/About';
// import Blog from './components/Blog';
import BlogDetail from './components/BlogDetail';
import Contactme from './components/Contactme';
import Footer from './components/Footer';
import BackToTop from './components/BackToTop';
import ThemeToggle from './components/ThemeToggle';

// Main portfolio page component
const PortfolioPage = () => {
    // const navigate = useNavigate();

    // const handleNavigateToBlog = (postId) => {
    //     // Get the blog post to find its slug
    //     const blogPosts = [
    //         { id: 1, slug: "building-ai-powered-development-automation-systems" },
    //         { id: 2, slug: "micro-frontend-architecture-react-typescript" },
    //         { id: 3, slug: "advanced-state-management-comparison" },
    //         { id: 4, slug: "graphql-performance-optimization" }
    //     ];
        
    //     const post = blogPosts.find(p => p.id === postId);
    //     if (post) {
    //         navigate(`/blog/${post.slug}`);
    //     }
    // };

    return (
        <div>
            <ThemeToggle />
            <Home />
            <BackToTop />
            <About />
            {/* <Blog onNavigateToBlog={handleNavigateToBlog} /> */}
            <Contactme />
            <Footer />
        </div>
    );
};

// Blog detail page component
const BlogDetailPage = () => {
    const { slug } = useParams();
    const navigate = useNavigate();

    // Map slugs to post IDs
    const slugToIdMap = {
        "building-ai-powered-development-automation-systems": 1,
        "micro-frontend-architecture-react-typescript": 2,
        "advanced-state-management-comparison": 3,
        "graphql-performance-optimization": 4
    };

    const postId = slugToIdMap[slug];

    const handleBackToBlog = () => {
        navigate('/#blog');
        // Small delay to ensure navigation completes before scrolling
        setTimeout(() => {
            const blogSection = document.getElementById('blog');
            if (blogSection) {
                blogSection.scrollIntoView({ behavior: 'smooth' });
            }
        }, 100);
    };

    return (
        <div>
            <ThemeToggle />
            <BlogDetail 
                postId={postId} 
                onBack={handleBackToBlog}
            />
            <Footer />
        </div>
    );
};

class App extends React.Component {
    render() {
        return (
            <Router>
                <Routes>
                    <Route path="/" element={<PortfolioPage />} />
                    <Route path="/blog/:slug" element={<BlogDetailPage />} />
                    {/* Fallback route */}
                    <Route path="*" element={<PortfolioPage />} />
                </Routes>
            </Router>
        );
    }
}

export default App;